import React from 'react';
import { Link } from 'react-router-dom';
import Formsy from 'formsy-react';
import FormsyInput from '../form/FormsyInput';
import withUser from './withUser';
import withTracker from '../withTracker';
import Nav from '../nav/Nav';
import ReactResizeDetector from 'react-resize-detector';
import { breakpoints } from '../../const';

class Login extends React.Component {
  state = {
    email: '',
    password: '',
    windowWidth: 0,
    windowHeight: 0
  };

  render() {
    const { handleChange, login } = this;
    const { email, password } = this.state;
    const { role = 'client' } = this.props.match.params;
    return (
      <div className="login">
        <Nav windowWidth={this.state.windowWidth} />
        <ReactResizeDetector
          handleWidth
          handleHeight
          onResize={this.onResize}
          refreshMode="throttle"
          refreshRate={100}
        />
        <div className="login__wrap">
          <h1 className="login__h1">Sign In</h1>
          <h2 className="login__h2">Welcome Back</h2>
          <Formsy className="login__form" onValidSubmit={login}>
            <div className="row">
              <div className="row__item row__item--full">
                <FormsyInput
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={email}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                />
              </div>
            </div>
            <div className="row">
              <div className="row__item row__item--full">
                <FormsyInput
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={handleChange}
                  autoComplete="off"
                  required
                />
              </div>
            </div>

            <div className="row">
              <div className="row__item row__item--full">
                <input
                  type="submit"
                  className="btn btn--pale-blue btn--full-width"
                  value="Sign In"
                />
              </div>
            </div>

            <div className="row">
              <div className="row__item row__item--full">
                <Link
                  to={`/forgot-password/${role}`}
                  className="btn btn--link-pale btn--full-width"
                >
                  Forgot your password?
                </Link>
              </div>
            </div>

            {role === 'client' && (
              <div className="row">
                <div className="row__item row__item--full a--center">
                  <p className="p p--green --inline">Are you a chef?</p>
                  <Link to="/login/chef" className="a--blue a--inline">
                    Sign in Here
                  </Link>
                </div>
              </div>
            )}
          </Formsy>
        </div>
      </div>
    );
  }

  /* Resize */
  onResize = (windowWidth, windowHeight) => {
    const isMobile = windowWidth < breakpoints.tablet;
    this.setState({ isMobile, windowWidth, windowHeight });
  };

  login = () => {
    const { role = 'client' } = this.props.match.params;
    const user = { ...this.state, role };
    const redirectTo = this.props.location.state
      ? this.props.location.state.from.pathname
      : '/';

    this.props.login(user, redirectTo);
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
}
export default withUser(withTracker(Login));



// WEBPACK FOOTER //
// ./src/components/auth/Login.js